import db from "../firebase/fireInit";
import ObjectListHolder from "../misc/elements/ObjectListHolder";
import { forArrayLength, getId, makeSearchArray } from "../misc/helperfuncs";
import { doc, setDoc } from "firebase/firestore";

function handleRatings(inputObject) {
  const fireObject = {};
  fireObject.ratings = {
    active: { first: 0, second: 0 },
    general: {
      first: inputObject.ratings.first.rating,
      second: inputObject.ratings.second.rating,
    },
    completed: { first: 0, second: 0 },
  };

  return fireObject;
}

function setDataDocs(inputObject, player, handleBoxTypes) {
  const boxType = handleBoxTypes.getBoxType(inputObject.type);
  const documents = ["categories", "keywords", "things"];
  if (handleBoxTypes.getAllBoxTypes(true).includes(inputObject.type)) {
    documents.push("generalFirst");
    documents.push("generalSecond");
    documents.push("activeFirst");
    documents.push("activeSecond");
    documents.push("completedFirst");
    documents.push("completedSecond");
    documents.push("images");
    documents.push("longDescriptions");
    documents.push("saved");
    documents.push("open");
    documents.push("completed");
    documents.push("active");
    documents.push("time");
  }

  if (["focus"].includes(inputObject.type)) {
    documents.push("active");
    documents.push("saved");
  }
  if (inputObject.type == "change") {
    document.push("completedFirst");
    document.push("completedSecond");
  }

  boxType.related.types.forEach((boxType) => {
    documents.push(boxType);
  });

  forArrayLength(documents, (document) => {
    const docObject = {};
    docObject.changed = false;
    docObject.id = inputObject.id;

    if (document == "generalFirst") {
      docObject.name = inputObject.ratings.first.name;
      docObject.ratings = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      };
      if (inputObject.ratings.first.rating > 0)
        docObject.ratings[inputObject.ratings.first.rating].push(player.uid);
    }
    if (document == "generalSecond") {
      docObject.name = inputObject.ratings.second.name;
      docObject.ratings = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      };
      if (inputObject.ratings.second.rating > 0)
        docObject.ratings[inputObject.ratings.second.rating].push(player.uid);
    }
    if (document == "activeFirst") {
      docObject.ratings = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      };
    }
    if (document == "activeSecond") {
      docObject.ratings = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      };
    }
    if (document == "completedFirst") {
      docObject.ratings = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      };
    }
    if (document == "completedSecond") {
      docObject.ratings = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      };
    }
    if (document == "longDescriptions") {
      docObject.descriptions = [];
      if (inputObject.longDescription.length > 0)
        docObject.descriptions.push({
          text: inputObject.longDescription,
          player: player.uid,
          upvotes: 1,
          upvoted: [player.uid],
        });
    }
    if (document == "categories") {
      docObject.object = {};
      inputObject.categories.forEach((c) => {
        docObject.object[c] = [player.uid];
      });
    }
    if (document == "keywords") {
      docObject.object = {};
      inputObject.keywords.forEach((k) => {
        docObject.object[k] = [player.uid];
      });
    }
    if (document == "things") {
      docObject.object = {};
      inputObject.things.forEach((t) => {
        docObject.object[t] = [player.uid];
      });
    }
    if (document == "images") {
      if (inputObject.image != null)
        docObject.urls = { [inputObject.image]: 0 };
    }

    if (boxType.related.types.includes(document)) {
      docObject.related = {};
      forArrayLength(inputObject[document], (d) => {
        docObject.related[d.id] = [player.uid];
      });
    }

    if (document == "time") {
      docObject.estimates = [];
      docObject.durations = [];
      if (inputObject.time > 0) docObject.estimates.push(inputObject.time);
    }
    if (document == "open") {
      docObject.player = [player.uid];
    }
    if (document == "saved") {
      docObject.player = [player.uid];
    }
    if (document == "active") {
      docObject.player = [];
    }
    if (document == "completed") {
      docObject.reports = [];
    }
    const docRef = doc(
      db,
      `boxes/${handleBoxTypes.getPluralType(inputObject.type)}/collection/${
        inputObject.id
      }/data`,
      document
    );
    setDoc(docRef, docObject);
  });
}

function saveObject(
  object,
  type,
  player,
  onObjectUploaded,
  addGeneralObjects,
  handleBoxTypes
) {
  const fireObject = handleRatings(object);
  const boxType = handleBoxTypes.getBoxType(object.type);

  // collection
  fireObject.collection = "general";
  // type
  fireObject.type = type;
  // id
  fireObject.id = object.id;
  // short description
  fireObject.shortDescription = object.shortDescription;
  // searchArray
  fireObject.searchArray = makeSearchArray(object.id);

  // categories
  fireObject.categories = object.categories;

  // things
  fireObject.things = object.things;

  // image
  if (object.image) fireObject.image = object.image;

  // keywords
  if (object.keywords) {
    fireObject.keywords = object.keywords;
  }

  // timeEstimate
  if (object.time != null) {
    fireObject.time = { estimate: 0, durations: 0 };
    if (object.timeEstimate > 0) fireObject.time.estimate += object.time;
  } else {
    fireObject.time = { durations: 0 };
  }
  forArrayLength(boxType.related.types, (bType) => {
    fireObject[bType] = object[bType].map((o) => o.id);
  });

  // open active save completed
  if (handleBoxTypes.getAllBoxTypes(true).includes(type)) {
    fireObject.active = 0;
    fireObject.open = 1;
    fireObject.saved = 1;
  }

  if (["focus"].includes(type)) {
    fireObject.active = 0;
    fireObject.saved = 1;
  }

  if (boxType.points) {
    fireObject.points = { total: 0, today: 0, week: 0, month: 0 };
  }

  const docRef = doc(
    db,
    `boxes/${handleBoxTypes.getPluralType(type)}/collection`,
    fireObject.id
  );
  addGeneralObjects([fireObject], handleBoxTypes.getPluralType);
  setDoc(docRef, fireObject).then(() => {
    setDataDocs(object, player, handleBoxTypes);
    onObjectUploaded(object, fireObject.id);
  });
}

function makeOpenObject(object, type) {
  const obj = {
    ...object,
    collection: "open",
    type,
    images: [],
    reports: [],
    focuses: [],
    thoughts: [],
    statements: [],
    date: {
      opened: Date.now(),
      closed: null,
    },
    points: { own: 0, others: 0 },
    minutes: { open: 0, active: 0 },
    rating: {
      active: {
        first: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        second: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      },
      general: {
        first: object.ratings.first.rating,
        second: object.ratings.second.rating,
      },
    },
    private: false,
    moods: {
      angry: 0,
      sad: 0,
      happy: 0,
      productive: 0,
      confused: 0,
      exhausted: 0,
    },

    partners: [],
    completed: false,
    actives: [],
  };

  if (type == "goal") {
    obj.completed = {
      tasks: [],
      problems: [],
      goals: [],
      leasures: [],
      routines: [],
      events: [],
      vices: [],
    };
  }

  return obj;
}

function makeSavedObject(object, boxType) {
  const related = {};

  forArrayLength(boxType.related.types, (r) => {
    related[r] = object[r];
  });

  return {
    ...related,
    collection: "saved",
    type: object.type,
    shortDescription: object.shortDescription,
    image: object.image ?? null,
    things: object.things,
    categories: object.categories,
    keywords: object.keywords,
    opened: 1,
    putInActive: 0,
    id: object.id,
    removedFromActive: 0,
    completed: 0,
    lastActive: null,
    private: false,
  };
}

function makeActiveObject(object) {
  return {
    time: 0,
    id: object.id,
    type: object.type,
    shortDescription: object.shortDescription,
    image: object.image ?? null,
    ratings: {
      first: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      second: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    },
    date: Date.now(),
    moods: {
      angry: 0,
      sad: 0,
      happy: 0,
      productive: 0,
      confused: 0,
      exhausted: 0,
    },
  };
}

export { saveObject, makeOpenObject, makeSavedObject, makeActiveObject };
